<template>
  <b-modal id="add-edit-discliamers-modal" scrollable ref="addEditDisclaimerModal" size="lg" hide-footer @show="beforeModalShow" @hidden="resetModalValues" @close="askDoubleConfirmation" :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop">
    <template slot="modal-header">
      <!-- Emulate built in modal header close button action -->
      <b-button type="button" aria-label="Close" class="close" @click="askDoubleConfirmation()">×</b-button>
      <h5 class="modal-title">Add a disclaimer</h5>
    </template>
    <div class="disclaimer-section">
      <div v-if="disclaimerList.length > 0" class="input-boxes mt-5">
        <transition-group name="list" tag="p">
          <div v-for="(disclaimerObj, dIndex) in disclaimerList" :key="`add-edit-disclaimer-${dIndex}`" class="form-group">
            <label class="heading3">Disclaimer {{ dIndex + 1 }}</label>
            <quill-editor class="bg-white" ref="consentDisclaimerEditor" v-model="disclaimerObj.disclaimer" :options="editorDisclaimerOptions"> </quill-editor>
            <span @click="removeDisclaimer(dIndex, disclaimerObj.dynamicDisclaimerID)" class="disclaimer-remove">Remove</span>
            <div class="optional-required mt-10">
              Set disclaimer as required or optional
            </div>
            <div class="re-opt-btn">
              <div class="btn-group">
                <label class="btn btn-default">
                  <input type="radio" class="disclaimer-radio" :name="'Disclaimer' + dIndex" v-model="disclaimerObj.required" value="true" />
                  <span class="ml-10 req-opt-lbl">Required</span>
                </label>
                <label class="btn btn-default"> <input type="radio" class="disclaimer-radio" :name="'Disclaimer' + dIndex" v-model="disclaimerObj.required" value="false" /><span class="ml-10 req-opt-lbl">Optional</span> </label>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
      <button @click="addDisclaimer()" type="button" class="btn btn-outline-primary btn-add-disclaimer">
        Add a disclaimer
      </button>
    </div>
    <div class="text-right">
      <button @click="saveDisclaimer()" type="button" class="btn btn-primary btn-save">
        Save
      </button>
    </div>
  </b-modal>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import _ from "lodash";

export default {
  name: "addEditDislaimersModal",
  components: {
    quillEditor
  },
  props: ["disclaimers", "totalPdfImages", "signingTabs"],
  data() {
    return {
      noCloseOnBackdrop: true,
      disclaimerList: [],
      editorDisclaimerOptions: {
        placeholder: "Enter disclaimer content",
        readOnly: false,
        modules: {
          toolbar: ["bold", "italic", "underline"]
        }
      },
      dynamicDisclaimerID: 0
    };
  },
  methods: {
    show() {
      this.addDynamicDiscliamerID();
      this.$refs.addEditDisclaimerModal.show();
    },
    hide() {
      this.$refs.addEditDisclaimerModal.hide();
    },
    resetModalValues() {},
    addDisclaimer() {
      const newDisclaimer = {
        disclaimer: "",
        disclaimerId: null,
        status: true,
        required: false,
        active: true,
        dynamicDisclaimerID: ++this.dynamicDisclaimerID
      };
      this.disclaimerList.push(newDisclaimer);
    },
    removeDisclaimer(index, dynamicDisclaimerID) {
      let warningMsg = "Are you sure you want to remove this disclaimer?";
      //find out if there are any fields configured on the discliame page
      //if yes then we need to show the warning message a/c to it
      const mainDisclaimersLength = this.disclaimers.length;
      const disclaimerPageBeingRemoved = this.totalPdfImages;
      let hasConfField = -1;
      if (dynamicDisclaimerID <= mainDisclaimersLength) {
        hasConfField = _.findIndex(this.signingTabs, function(st) {
          return st.pageNumber == disclaimerPageBeingRemoved && st.active;
        });

        if (hasConfField >= 0) {
          //It means there are fields configured on this disclaimer page.
          warningMsg = "You are about to delete a disclaimer. Any fields configured on the disclaimer page will be deleted as well. Would you like to proceed?";
        }
      }

      this.$swal({
        title: warningMsg,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$emit("deleteDisclaimerPage", disclaimerPageBeingRemoved);

          if (this.disclaimerList[index].disclaimerId) {
            this.disclaimerList[index].active = false;
            this.$emit("deleteExistingDiscliamer", this.disclaimerList[index]);
            this.disclaimerList.splice(index, 1);
          } else {
            this.disclaimerList.splice(index, 1);
          }
        }
      });
    },
    askDoubleConfirmation() {
      this.$swal({
        title: "Are you sure you want to close this screen? Any changes made will not be saved.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          //If a user has delete existing disclaimer and now he do not wants to save the changes then reset
          this.$emit("resetDeletedDisclaimer");
          this.disclaimerList = _.cloneDeep(this.disclaimers); //Reset to original one
          this.hide();
        }
      });
    },
    saveDisclaimer() {
      //validate Disclaimers
      if (this.disclaimerList.length > 0) {
        for (let i = 0; i < this.disclaimerList.length; i++) {
          if (this.disclaimerList[i].disclaimer.trim() == "") {
            this.$toastr.error("Please enter disclaimer content");
            return;
          }
        }
      }

      this.$emit("saveDisclaimers", _.cloneDeep(this.disclaimerList));
      this.hide();
    },
    beforeModalShow() {
      this.addDefaultDisclaimer();
    },
    addDefaultDisclaimer() {
      if (this.disclaimers && this.disclaimers.length == 0) {
        this.addDisclaimer();
      }
    },
    addDynamicDiscliamerID() {
      const disclaimersList = this.disclaimers && this.disclaimers.length > 0 ? _.cloneDeep(this.disclaimers) : [];
      this.dynamicDisclaimerID = disclaimersList.length;

      _.map(disclaimersList, (d, index) => {
        d.dynamicDisclaimerID = index + 1;
        return d;
      });
      this.disclaimerList = disclaimersList;
    }
  },
  mounted() {
    this.addDynamicDiscliamerID();
  }
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  #add-edit-discliamers-modal {
    .modal-dialog {
      min-width: 840px !important;
      max-height: calc(100% - 1rem);
      margin: 3.125rem auto;
    }
  }
}

#add-edit-discliamers-modal {
  .modal-content {
    .modal-header {
      border-bottom: 0;
      padding-left: 32px;
      padding-top: 22px;

      h5.modal-title {
        font-size: 16px;
        color: #4a4a4a;
        font-weight: bold;
      }

      button.close {
        position: absolute;
        top: 8px;
        right: 15px;
        color: #a9b0b4;
        background: transparent;
        border: 0;

        &:active {
          color: #a9b0b4;
          background: transparent;
          border: 0;
        }

        &:hover {
          background: transparent;
          border: 0;
        }

        &:focus {
          background: transparent;
          border: 0;
        }
      }
    }

    .modal-body {
      padding-top: 0;
      padding-left: 30px;
      padding-right: 27px;
      padding-bottom: 4px;
      overflow-y: hidden;
      margin-bottom: 19px;

      .disclaimer-section {
        .heading {
          margin-top: 20px;
          font-size: 16px;
          color: #4a4a4a;
          font-weight: bold;
        }

        .form-group {
          position: relative;

          label {
            color: #4a4a4a;
            margin-bottom: 0.125rem;
            font-size: 14px;
            font-weight: 600;
            line-height: 1.43;
          }

          textarea {
            border-radius: 3px;
            border: solid 1px #e4e8eb;
            width: 91%;
          }

          &:last-of-type {
            margin-bottom: 0;
          }

          .quill-editor {
            width: 91%;

            .ql-toolbar {
              &.ql-snow {
                border: solid 1px #e4e8eb;
                background-color: #f5f6f7;
                padding: 4px;
              }
            }

            .ql-container {
              &.ql-snow {
                border: solid 1px #e4e8eb;
                border-top: 0;
                border-radius: 3px;
              }

              .ql-editor {
                padding-left: 11px;
                min-height: 57px;

                &.ql-blank {
                  &::before {
                    font-style: normal;
                    color: #9b9b9b;
                    font-size: 14px;
                    left: 10px;
                  }
                }
              }
            }
          }

          .optional-required {
            color: #4a4a4a;
          }

          .re-opt-btn {
            margin-left: 11px;

            span.req-opt-lbl {
              font-weight: normal;
            }

            .disclaimer-radio {
              transform: scale(1.4);
            }
          }

          .disclaimer-remove {
            color: #f66855;
            position: absolute;
            top: 40%;
            right: 0;
            cursor: pointer;
          }
        }

        .btn-add-disclaimer {
          border-radius: 3px;
          font-size: 12px;
          color: #1e8fe1;
          border: solid 1px #1e8fe1;
          margin-top: 5px;
          padding: 7px 15px;

          &:hover {
            color: #fff;
          }
        }

        .list-enter-active,
        .list-leave-active {
          transition: opacity 0.5s;
        }

        .list-enter,
                .list-leave-to

                /* .fade-leave-active below version 2.1.8 */
 {
          opacity: 0;
        }
      }

      button {
        &.btn-primary {
          &.btn-save {
            padding: 7px 35px;
            font-size: 14px;
            border: solid 1px #1e8fe1;
            background-color: #1e8fe1;
          }
        }
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 1111px) {
  .modal-dialog {
    max-width: 700px;
    width: 700px;
  }

  #add-edit-discliamers-modal {
    .modal-content {
      .modal-body {
        .disclaimer-section {
          .form-group {
            .quill-editor {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
